export const SEARCH_TERM = 'search_term';

export const SEARCH_PATH = '/search';
